<template>
  <div class="layout-col -pt-5">
    <section class="-wrapper-tile -wrapper-column fitting- -border-radius-1">
      <div class="-header">
        <div class="-wrapper-column">
          <p class="-h2 -font-weight-medium">{{ $t('pages_contract_ContractDetail.contract.productByKrw') }}</p>
        </div>

      </div>
      <div class="-tile-container -bg-white -border-radius-1 -overflow-x-hidden -overflow-y-hidden">
        <div class="-wrapper-between">
          <g-search-bar
            id="contract-detail-grid-searchbar"
            full
            no-border
            placeholder="Search anything"
            v-model="searchText"
          />
          <g-button
            id="contract-detail-grid-excel-download"
            variant="borderless"
            size="small"
            icon-only
            class="-minus-ml-2 -mt-2"
            @click="onClickDownload">
            <g-icon name="get_app"  width="16px" height="16px" color="gray-1" tag="span"/>
          </g-button>
        </div>
        <ag-grid-vue
          id="contract-detail-list-grid"
          style="height: 631px;"
          class="ag-theme-balham"
          row-height="30"
          header-height="30"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefs"
          :gridOptions="gridOptions"
          :rowData="productList"
          :modules="modules"
          @grid-ready="onGridReady"
          @row-clicked="openPopupDetail"
          @row-data-changed="onRowDataChanged"
          @pagination-changed="paginationChanged">
        </ag-grid-vue>
        <g-pagenation
          id="contract-detail-list-grid-paging"
          class="-py-6 -pr-2"
          :page-no="paging.pageNo == 0 ? 1 : paging.pageNo"
          :page-size-list="pageSizeList"
          :page-size="paging.size"
          :total-count="paging.totalCount"
          @change-page-no="onChangePageNo"
          @change-page-size="onChangePageSize"/>
      </div>
    </section>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import AgGridMixin from "@/pages/mixin/AgGrid.mixin";
import {DEFAULT_OPTION_PER_PAGE, DEFAULT_PAGE_SIZE, AUTH_GROUP, LOCALE, CURRENCY_SYMBOL} from "@/constants/constants";
import {mapActions, mapGetters} from "vuex";
import CodeList from "@/code/CodeList";
import ConstractDetailPopup from "@/pages/contract/components/components/ConstractDetailPopup";
import moment from "moment";
export default {
  name: 'ContractDetailCostByInvoice',
  componentName: 'ContractDetailCostByInvoice',
  components: {
    AgGridVue
  },
  mixins: [AgGridMixin()],
  computed: {
    ...mapGetters('contract', ['productList','contractDetail']),
  },
  props : {
    billMonth : {
      type : Object,
      default :()=> {}
    }

  },
  data () {
    return {
      pageSizeList: DEFAULT_OPTION_PER_PAGE,
      paging : {
        pageNo : 1,
        size : DEFAULT_PAGE_SIZE,
        startIndex : 0,
        totalCount : 0,
      },
      columnDefs: [],
      searchText: '',
    }
  },
  methods: {
    ...mapActions('contract', ['getContractsProductsWithId']),
    onGridReady(params) {
      this.setGridParams(params)
      this.fitGrid()
    },
    openPopupDetail(target) {
      this.$popupManager.open(ConstractDetailPopup, {companyCode: target.data.companyCode, id: target.data.id, month: this.billMonth.month, prodId: target.data.productNo})
    },
    setColumn () {
      this.columnDefs = [
        {
          field: 'productName',
          headerName: this.$t('pages_contract_ContractDetail.productName'),
          sortable: true,
          cellStyle : {"cursor":"pointer"},
          unSortIcon: true,
        },
        {
          field: 'productStartDate',
          headerName: this.$t('pages_contract_ContractDetail.contract.product.startDate'),
          sortable: true,
          width: 100,
          cellStyle : {"cursor":"pointer"},
          unSortIcon: true
        },
        {
          field: 'productEndDate',
          headerName: this.$t('pages_contract_ContractDetail.contract.product.endDate'),
          sortable: true,
          width: 100,
          cellStyle : {"cursor":"pointer"},
          unSortIcon: true
        },

        {
          field: 'contractStatusName',
          headerName: this.$t('pages_contract_ContractDetail.contract.contractStatusName'),
          sortable: true,
          cellStyle : {"cursor":"pointer"},
          unSortIcon: true,
        //  width: 70,
          cellRenderer : parameter => {
            if( parameter.value ===this.$t('pages_contract_ContractInfo.contract.ing') ){
              return '<p class="-tag green-">'+parameter.value+'</p>';
            } else if( parameter.value === this.$t('pages_contract_ContractDetail.contract.end') ) {
              return '<p class="-tag gray-">'+parameter.value+'</p>';
            } else if( parameter.value === this.$t('pages_contract_ContractDetail.contract.needextend')) {
              return '<p class="-tag yellow-">'+parameter.value+'</p>';
            } else if( parameter.value ===this.$t('pages_contract_ContractDetail.contract.exceed')) {
              return '<p class="-tag red-">'+parameter.value+'</p>';
            } else if( parameter.value ==='-') {
              return '<p>'+parameter.value+'</p>';
            } else if( parameter.value ==='') {
              return '<p>'+parameter.value+'</p>';
            }

          }
        },

        {
          field: 'totalTradeAmount',
          headerName: this.$t('pages_contract_ContractDetail.contract.productKrw'),
          unSortIcon: true, comparator: this.numberSort, cellStyle: { 'text-align': "right", "cursor":"pointer"},
          cellRenderer: (params) => {
            return CURRENCY_SYMBOL.KRW +  parseInt(params.value).toLocaleString()
          }},

      ]
    },
    onRowDataChanged (e) {
      if (this.codeCustomerList === CodeList.READY) {
        this.noRowsOverlayComponentParams.exception = false
        this.gridApi.showLoadingOverlay()
      } else if (this.codeCustomerList === CodeList.EXCEPTION) {
        this.noRowsOverlayComponentParams.exception = true
        this.gridApi.showNoRowsOverlay()
      } else if (this.codeCustomerList === CodeList.SUCCESS) {
        if (this.customerListByGroupId.length > 0) {
          this.gridApi.hideOverlay()
        } else {
          this.gridApi.showNoRowsOverlay()
        }
      }

      this.paging.totalCount = e.api.rowModel.rowsToDisplay.length
      this.fitGrid()
    },
    paginationChanged (e) {
      this.paging.totalCount = e.api.rowModel.rowsToDisplay.length
    },
    onChangePageNo (pageNo) {
      this.paging.pageNo = pageNo;
      this.gridApi.paginationGoToPage(pageNo - 1);
    },
    onChangePageSize (pageSize) {
      this.paging.size = pageSize;
      this.paging.pageNo = 1;
      this.fitGrid();
      this.gridApi.paginationSetPageSize(this.paging.size);
      this.gridApi.paginationGoToPage(this.paging.pageNo - 1);
    },
    onClickDownload () {

      let params = {
        fileName: 'USE_PRODUCT_LIST',
        allColumns: true,

      }
      this.gridApi.exportDataAsCsv(params);
    },
    numberSort (num1, num2) {
      return num1 - num2;
    },
  },
  watch: {
    billMonth :  {
     handler(value){

       this.getContractsProductsWithId(value)
     },
      deep: true,
      immediate : true

    },
    searchText () {
      this.gridOptions.api.setQuickFilter(this.searchText)
      this.paging.pageNo = 1;
      this.gridApi.paginationGoToPage(this.paging.pageNo - 1);
    },

  },


}
</script>




// WEBPACK FOOTER //
// src/pages/contract/components/ContractDetailCostByInvoice.vue